import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClock } from "@fortawesome/free-regular-svg-icons";
import blankProfile from './../../../../assets/image/blankProfile.webp';
import { io } from "socket.io-client";
import { API_BASE_URL, GET_EMPLOYEES_ON_LEAVE_TODAY } from "../../../../config/config";
import { useEffect, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";

interface logProps {
    profile_picture : string;
    full_name : string;
    time : string;
    status : string;
    work_setup : string;
}

interface leaveAnalyticsProps {
    fullname : string;
    leave_type : string;
    isHalfday : boolean;
}

const AttendanceDetails = () => {
    const [logs, setLogs] = useState<logProps[] | null>(null);
    const [onLeaveToday, setOnLeaveToday] = useState<leaveAnalyticsProps[] | null>(null);

    useEffect(()=>{
        const getEmpOnLeaveToday = async() => {
            try{
                const data = await api.get(GET_EMPLOYEES_ON_LEAVE_TODAY, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const leaveData = data.data as leaveAnalyticsProps[];
                if(leaveData.length > 0) setOnLeaveToday(leaveData);
            }catch(e){}
        }
        getEmpOnLeaveToday();
    },[]);

    useEffect(() => {
        const socket = io(API_BASE_URL);
    
        socket.on('attendance_log', (log: logProps[]) => {
          setLogs(log);
        });
    
        return () => {
          if (socket) {
            socket.disconnect();
          }
        };
      }, []);

      const date = new Date();
      const current_date = date.toISOString().split('T')[0];

      const formatDate = (dateString: string | undefined): string => {
        if(!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    return(
        <div className="flex gap-2 w-full">
        <div className="bg-white shadow-xl rounded p-2 w-full">
            <div>
                <h1>
                    <FontAwesomeIcon icon={faClock} /> &nbsp;
                    Time log today ({formatDate(current_date)})
                </h1>
            </div>
            <div className="flex gap-2 items-center w-full mt-2 uppercase border py-2">
                <h2 className="w-full text-center">Name</h2>
                <h2 className="w-full text-center">Time</h2>
                <h2 className="min-w-36 text-center">Status</h2>
            </div>
            <div className="flex flex-col max-h-64 overflow-y-auto">
                {logs ? logs.map(log => (
                    <div className="flex gap-2 items-center w-full border px-4 py-2 rounded shadow hover:bg-gray-200">
                        <div className="w-full flex items-center gap-2">
                            <div>
                                <img src={blankProfile} className='account-img' alt="userProfile" />
                            </div>
                            <div>
                                <div>{log.full_name}</div>
                                <div>
                                    <small className={`${log.work_setup === 'wfh' ? 'bg-blue-400' : 'bg-yellow-500'} px-2 rounded shadow text-blue-50`}>
                                        {log.work_setup}
                                    </small>            
                                </div>
                            </div>
                        </div>
                        <div className="w-full text-center">{log.time}</div>
                        <div className={
                            log.status === 'Signed in' ? "min-w-28 text-center rounded shadow bg-green-300" : 
                            log.status === 'Signed out' ? "min-w-28 text-center rounded shadow bg-gray-300" :
                            log.status === "Off Break" ? "min-w-28 text-center rounded shadow bg-orange-200" : 
                            "min-w-28 text-center rounded shadow bg-orange-400"
                            }>
                            {log.status}
                        </div>
                    </div>
                )) : (
                    <div>
                        No attendance log today
                    </div>
                )}

            </div>
        </div>
        <div className="bg-white shadow-xl rounded p-2 w-3/4">
            <div>
                <h1>
                    <FontAwesomeIcon icon={faCalendar} />&nbsp;
                    Employee/s on leave today
                </h1>
            </div>
            <div className="flex gap-2 items-center w-full mt-2 uppercase border py-2">
                <h2 className="w-full text-center font-semibold">{formatDate(current_date)} Leave data</h2>
            </div>
            <div className="flex flex-col max-h-64 overflow-y-auto">
                {onLeaveToday ? onLeaveToday.map(leave =>(
                    <div className="flex gap-2 items-center w-full border px-4 py-2 rounded shadow hover:bg-gray-200">
                        <div className="w-full flex items-center gap-2">
                            <img src={blankProfile} className='account-img' alt="userProfile" />
                            <div className="flex flex-col">
                                <h3>{leave.fullname}</h3>
                                <small className="bg-green-300 text-center rounded-lg shadow">{leave.leave_type === 'vl' ? "Vacation Leave" : "Emergency/Sick Leave"}</small>
                            </div>
                        </div>
                        <div className="min-w-24 text-center text-sm bg-orange-300 rounded-xl shadow uppercase">{leave.isHalfday ? 'Half-day' : 'Whole day'}</div>
                    </div>
                )) : (
                    <div>
                        No employee on leave today
                    </div>
                )}
            </div>
        </div>
    </div>
    )
}

export default AttendanceDetails;